import JSBI from 'jsbi'

export const FixedPoint128 = JSBI.exponentiate(JSBI.BigInt(2), JSBI.BigInt(128))